// extracted by mini-css-extract-plugin
module.exports = {"bg":"GlowCardResponsive_bg__-hB6g","box":"GlowCardResponsive_box__2W3ue","imgbx":"GlowCardResponsive_imgbx__25REn","content":"GlowCardResponsive_content__15gSQ"};